import { cleverTapAnl } from 'utilities';
import { EventPermissionsAllow, EventPermissionsDeny } from 'utilities/clevertapEvent';
import { mediaPermissionsStatusMapping } from './constants';

export function getLocalStreamPermission(params, type) {
  navigator.mediaDevices.getUserMedia(params).then(() => {
    cleverTapAnl.event({
      event_name: 'permissions_allow',
      event: {
        permission_type: type,
      },
    } as EventPermissionsAllow);
  }).catch(() => {
    cleverTapAnl.event({
      event_name: 'permissions_deny',
      event: {
        permission_type: type,
      },
    } as EventPermissionsDeny);
  });
}

export function getMediaPermissions() {
  const hasAccess = {
    audio: false,
    video: false,
  };

  if (navigator?.permissions) {
    Promise.all([
      navigator.permissions.query({ name: 'microphone' as PermissionName }),
      navigator.permissions.query({ name: 'camera' as PermissionName }),
    ]).then(function ([audio, video]) {
      if (audio.state === mediaPermissionsStatusMapping.PROMPT || video.state === mediaPermissionsStatusMapping.PROMPT) {
        hasAccess.audio = audio.state === mediaPermissionsStatusMapping.GRANTED;
        hasAccess.video = video.state === mediaPermissionsStatusMapping.GRANTED;
        if (!(hasAccess.audio && hasAccess.video)) {
          let type = 'audio_video';
          switch (true) {
            case hasAccess.audio:
              type = 'video';
              break;
            case hasAccess.video:
              type = 'audio';
              break;
          }
          getLocalStreamPermission({ video: !hasAccess.video, audio: !hasAccess.audio }, type);
        }
      }
    });
  }
}

const triggerPermissions = async () => {
  try {
    // Request microphone and camera permissions
    await navigator.mediaDevices.getUserMedia({ audio: true, video: true });
    console.log('Permissions granted');
    return true;
  } catch (err) {
    console.error('Permission denied:', err);
    return false;
  }

};

export async function checkMediaPermissions() {
  try {
    const cameraPermission = await navigator.permissions.query({ name: 'camera' });
    const microphonePermission = await navigator.permissions.query({ name: 'microphone' });

    const cameraStatus = cameraPermission.state;
    const microphoneStatus = microphonePermission.state;

    console.log('Camera Permission Status:', cameraStatus);       // 'granted', 'denied', or 'prompt'
    console.log('Microphone Permission Status:', microphoneStatus); // 'granted', 'denied', or 'prompt'

    // Check if both permissions are granted
    if (cameraStatus === mediaPermissionsStatusMapping.GRANTED && microphoneStatus === mediaPermissionsStatusMapping.GRANTED) {
      console.log('Camera and Microphone access already granted.');
      return mediaPermissionsStatusMapping.GRANTED;
    } else if (cameraStatus === mediaPermissionsStatusMapping.PROMPT && mediaPermissionsStatusMapping.PROMPT) {
      const permissionsStatus = await triggerPermissions();
      return permissionsStatus ? mediaPermissionsStatusMapping.GRANTED : mediaPermissionsStatusMapping.DENIED;
    } else {
      console.log('Camera and Microphone access denied.');
      return mediaPermissionsStatusMapping.DENIED;
    }

  } catch (error) {
    console.error('Permission API not supported or an error occurred:', error);
    return mediaPermissionsStatusMapping.DENIED;
  }
}
